<!-- Hero Start -->

<ngx-ui-loader></ngx-ui-loader>
<section class="bg-half-170 bg-light d-table w-100" id="home"
  style="background: url('assets/banners/fe-rio-2.jpg') center center;">
  <div class="bg-overlay bg-overlay-white"></div>
  <div class="container">
    <div class="row mt-5 justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="pages-heading">
          <h4 class="title mb-0">{{ 'hotels.pageName' | translate }}</h4>
        </div>
      </div> <!--end col-->
    </div><!--end row-->

    <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/">LASA 2025</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ 'hotels.pageName' | translate }}</li>
        </ul>
      </nav>
    </div>
  </div> <!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!--Shape End-->

<section class="section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Sesc Copacabana - {{ 'hotels.official' | translate }}</h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/Copa-site-1140x480.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/DSC3746-1000x480.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/DSC3752-1000x480.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->


            <!--end col-->


            <!--end col-->


            <!--end col-->

            <!--end col-->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-4 col-md-6  mt-4 pt-2">
                <div class="card shadow rounded border-0">
                    <div class="card-body py-5">
                        <h4 class="card-title">Hotel SESC Copacabana</h4>
                        <div class="custom-form mt-3">
                            <h5>* {{ 'hotels.official' | translate }} </h5>
                            <div class="alert alert-danger" role="alert" [innerHTML]="'hotels.alert' | translate "></div>
                            <p><strong>{{ 'hotels.address' | translate }}</strong><br>
                                Rua Domingos Ferreira, 160 – Copacabana<br>
                                CEP: 22050-012<br>
                                Rio de Janeiro/ Brasil</p>
                            <p>{{ 'hotels.phone' | translate }}: <br> + 55 (21) 4020-2101  <br> + 55 (21) 2548-1088</p>
                            <p>
                                <a class="btn btn-lg btn-success" data-bs-toggle="modal" data-bs-target="#subscribe-popup">{{ 'hotels.button' | translate }}</a>
                            </p>

                        </div>

                        <!--end custom-form-->
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-8 col-md-6 ps-md-3 pr-md-3 mt-4 pt-2">
                <div class="card map map-height-two rounded map-gray border-0">
                    <div class="card-body p-0">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.376008133829!2d-43.19061544354771!3d-22.973196787567844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bd544483de141%3A0x2c3793aac4fb1d8a!2sSesc%20Copacabana!5e0!3m2!1spt-BR!2sbr!4v1738175891786!5m2!1spt-BR!2sbr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>


<section class="section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Windsor California Copacabana Hotel</h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/windsor1.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/windsor2.jpg" height="237" width="100%" class="rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/windsor3.jpg" height="237" width="100%" class="rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->


            <!--end col-->


            <!--end col-->


            <!--end col-->

            <!--end col-->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6  mt-4 pt-2">
                <div class="card shadow rounded border-0">
                    <div class="card-body py-5">
                        <h4 class="card-title">Windsor California Copacabana Hotel</h4>
                        <div class="custom-form mt-3">

                            <p><strong>{{ 'hotels.address' | translate }}</strong><br>
                                Avenida Atlântica, 2616 – Copacabana<br>
                                CEP: 22041-001<br>
                                Rio de Janeiro, Brasil</p>
                            <p>{{ 'hotels.phone' | translate }}: <br> +55 (21) 2195-7800</p>
                            <p>
                                <a class="btn btn-lg btn-success" href="https://windsorhoteis.com/hotel/windsor-california-copacabana/?gad_source=1&gbraid=0AAAAAD8heSTYpXfqBCF6Wh0CjYYS12wKQ&gclid=CjwKCAiA5Ka9BhB5EiwA1ZVtvEZ0uy3bBVe_wxCfu68GB7MWrk5DxXqx4_lao3ojGlTshd2FygLF1hoC358QAvD_BwE" target="_blank">{{ 'hotels.button' | translate }}</a>
                            </p>

                        </div>

                        <!--end custom-form-->
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-8 col-md-6 ps-md-3 pr-md-3 mt-4 pt-2">
                <div class="card map map-height-two rounded map-gray border-0">
                    <div class="card-body p-0">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.395596858811!2d-43.188473923986585!3d-22.972476040223274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bd54509437463%3A0x34f900f74bab2bb0!2sWindsor%20California%20Copacabana%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1738339146183!5m2!1spt-BR!2sbr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->


    <!--end container-->
</section>
<!--end section-->
<!-- End contact -->
<section class="section bg-cta" style="background: url('assets/images/copacabana3.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{ 'home.ctaOne.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{ 'home.ctaOne.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank"  class="btn btn-danger btn-lg">{{ 'home.ctaOne.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>

<section class="section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Pestana Rio Atlântica Premium Copacabana Beach</h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/pestana1.jpeg" height="237" width="100%"  class="rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/pestana2.jpg" height="237" width="100%" class="rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/hotel/pestana3.jpg" height="237" width="100%" class="rounded" alt="work-image">
                        <div class="overlay-work"></div>

                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->


            <!--end col-->


            <!--end col-->


            <!--end col-->

            <!--end col-->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6  mt-4 pt-2">
                <div class="card shadow rounded border-0">
                    <div class="card-body py-5">
                        <h4 class="card-title">Pestana Rio Atlântica Premium Copacabana Beach</h4>
                        <div class="custom-form mt-3">

                            <p><strong>{{ 'hotels.address' | translate }}</strong><br>
                                Avenida Atlântica, 2964 - Copacabana<br>
                                CEP: 22070-000<br>
                                Rio de Janeiro, Brasil</p>
                            <p>{{ 'hotels.phone' | translate }}: <br> +55 21 3816-8500 <br> +55 11 4700-7794</p>
                            <p>
                                <a class="btn btn-lg btn-success" href="https://www.pestana.com/br/hotel/pestana-rio?gad_source=1&gbraid=0AAAAADSKHc45f9SYTFCq0NWaC39GnsbtJ&gclid=CjwKCAiA5Ka9BhB5EiwA1ZVtvDs7tzy8rcOpiit7Sbab2re6lncmM2PMh7NmM-IgEmFhiOx6_-WPChoCKvEQAvD_BwE" target="_blank"> {{ 'hotels.button' | translate }}</a>
                            </p>

                        </div>

                        <!--end custom-form-->
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-8 col-md-6 ps-md-3 pr-md-3 mt-4 pt-2">
                <div class="card map map-height-two rounded map-gray border-0">
                    <div class="card-body p-0">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.3274201695717!2d-43.19053002398641!3d-22.97498444031325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bd546e9f41ff1%3A0xbe264f1f33ad2d0e!2sPestana%20Rio%20Atl%C3%A2ntica!5e0!3m2!1spt-BR!2sbr!4v1738339324682!5m2!1spt-BR!2sbr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->


    <!--end container-->
</section>


<section class="section bg-cta" style="background: url('assets/images/copacabana.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">Não fique de fora</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">Clique no botão abaixo para se inscrever:</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank"  class="btn btn-danger btn-lg">Inscreva-se
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->

<div class="modal fade" id="subscribe-popup" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
            <div class="modal-header">
                <h4 class="card-title">Hotel SESC Copacabana</h4>
                <button type="button" class="btn-close float-end m-2" data-bs-dismiss="modal" aria-label="Close" #closeButton>x</button>
            </div>
            <div class="modal-body" [formGroup]="hotelForm">
                <div class="alert alert-danger" role="alert" [innerHTML]="'hotels.alert' | translate "></div>
                <div class="row">
                    <div class="col-md-12" [innerHTML]="'hotels.info' | translate">

                    </div>
                </div>
                <div class="container-fluid px-0">
                    <div class="row align-items-center g-0">
                        <div class="col-md-8">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.name' | translate }}  <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="name">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['name'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.birth' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="birthDate">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['birthDate'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                    </div><!--end row-->
                    <div class="row align-items-center g-0">
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.passport' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="document">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['document'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.phone' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="phone">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['phone'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.email' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="email" >
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['email'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                    <div class="row align-items-center g-0">
                        <div class="col-md-8">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.ladieName' | translate }}</label>
                                <input type="text" class="form-control" formControlName="ladieName">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.birth' | translate }}</label>
                                <input type="text" class="form-control" formControlName="ladieBirthDate">
                            </div>
                        </div>
                    </div><!--end row-->
                    <div class="row align-items-center g-0">
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.passport' | translate }}</label>
                                <input type="text" class="form-control" formControlName="ladieDocument">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.phone' | translate }}</label>
                                <input type="text" class="form-control" formControlName="ladiePhone">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.email' | translate }}</label>
                                <input type="text" class="form-control" formControlName="ladieEmail">
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center g-0">
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.zipCode' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="zipCode">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['zipCode'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.address' | translate }} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="address">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['address'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                    </div><!--end row-->
                    <div class="row align-items-center g-0">
                        <div class="col-md-8">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.guests' | translate }} <span class="text-danger">*</span></label>
                                <input type="number" class="form-control" formControlName="guests">
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['guests'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.bed' | translate }} <span class="text-danger">*</span></label>
                                <div class="list-inline">
                                    <label><input type="radio" name="bedType" value="single" formControlName="bedType">{{ 'hotels.form.single' | translate }}</label>
                                    <label><input type="radio" name="bedType" value="double" formControlName="bedType">{{ 'hotels.form.maried' | translate }}</label>
                                </div>
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['bedType'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12" [innerHTML]="'hotels.obs'| translate">


                        </div>
                    </div>
                    <div class="row align-items-center g-0">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">{{ 'hotels.form.options' | translate }} <span class="text-danger">*</span></label>
                                <label><input type="radio" name="options" value="5" formControlName="options">{{ 'hotels.form.opt5' | translate }}</label><br>
                                <label><input type="radio" name="options" value="1" formControlName="options">{{ 'hotels.form.opt1' | translate }}</label><br>
                                <label><input type="radio" name="options" value="2" formControlName="options">{{ 'hotels.form.opt2' | translate }}</label><br>
                                <label><input type="radio" name="options" value="3" formControlName="options">{{ 'hotels.form.opt3' | translate }}</label><br>
                                <label><input type="radio" name="options" value="4" formControlName="options">{{ 'hotels.form.opt4' | translate }}</label><br>
                                <ng-container *ngIf="hotelFormSend && hotelForm.controls['options'].errors">
                                    <p class="mt-1 text-danger">{{ 'hotels.required' | translate  }}</p>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div><!--end container-->
            </div>
            <div class="modal-footer">
                <button class="btn btn-lg btn-success" (click)="sendRequest()">{{'hotels.form.button'| translate}}</button>
            </div>
        </div>
    </div>
</div>


<swal
    #confirmHotel
    title= "{{'hotels.confirm.title' | translate}}"
    text="{{'hotels.confirm.message' | translate}}"
    icon="success">
</swal>
